module.exports = __webpack_public_path__ + "img/AAAFX-logo.58382687.png";